import { cpf } from "cpf-cnpj-validator";

import { Select, Row, Input, Form, Checkbox } from "antd";
import { useHistory } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";

import { listUF } from "../../../../utils/getUF";
import { InputCpf } from "../InputCpf";
import { InputPhone } from "../InputPhone";
import { InputRg } from "../InputRg";

import { InputMatricula } from "../../../../components/InputMatricula";

const { Option } = Select;

export function DadosPessoal(props) {
  const history = useHistory();

  return (
    <>
      <div
        className="loginContainer"
        onClick={() => {
          history.push("/login");
        }}
      >
        <ArrowLeftOutlined />
        <div className="login">Login</div>
      </div>
      <Row justify="center" align="middle">
        <div className="ant-descriptions-title">Dados de usuário</div>
      </Row>

      <br />
      <Form.Item
        className="inputStyle"
        name="isTercerizado"
        valuePropName="checked"
      >
        <Checkbox>Funcionário terceirizado?</Checkbox>
      </Form.Item>

      <Form.Item
        className="inputStyle"
        label="Nome completo"
        name="nome"
        rules={[
          { required: true, message: "Por favor informe seu nome completo!" },
        ]}
      >
        <Input />
      </Form.Item>

      <div className="duasCollumn">
        <Form.Item
          className="inputStyle"
          span={10}
          label="CPF"
          name="cpf"
          rules={[
            { required: true, message: "Por favor informe seu CPF!" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                console.log(cpf.isValid(value));
                if (!value || cpf.isValid(value)) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error("Por favor, preencha um CPF válido.")
                );
              },
            }),
          ]}
        >
          <InputCpf />
        </Form.Item>

        <div className="sizeBoxWidth" />

        <Form.Item
          className="inputStyle"
          shouldUpdate={(old, current) =>
            old.isTercerizado !== current.isTercerizado
          }
        >
          {({ getFieldValue }) => {
            return (
              <Form.Item
                className="inputStyle"
                span={10}
                label="Matrícula"
                name="matricula"
                rules={[
                  {
                    required: !getFieldValue("isTercerizado"),
                    message: "Por favor informe sua Matrícula!",
                  },
                ]}
              >
                <InputMatricula maxLength={7} />
              </Form.Item>
            );
          }}
        </Form.Item>
      </div>

      <div className="duasCollumn">
        <Form.Item
          className="inputStyle"
          label="RG"
          name="rg"
          rules={[{ required: false, message: "Por favor informe seu RG!" }]}
        >
          <InputRg max={13} />
        </Form.Item>

        <div className="sizeBoxWidth" />

        <Form.Item
          className="inputStyle"
          label="UF RG"
          name="estadoRg"
          rules={[{ required: false, message: "Por favor informe seu RG!" }]}
        >
          <Select
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {listUF.map((lista) => {
              return (
                <Option key={lista.id} value={lista.sigla}>
                  {lista.sigla}
                </Option>
              );
            })}
          </Select>
        </Form.Item>
      </div>
      <div className="duasCollumn">
        <Form.Item
          className="inputStyle"
          label="E-mail Institucional"
          name="email"
          rules={[{ required: true, message: "Por favor informe seu E-mail!" }]}
        >
          <Input type="email" />
        </Form.Item>

        <div className="sizeBoxWidth" />

        <Form.Item
          className="inputStyle"
          label="Telefone"
          name="telefone"
          rules={[
            { required: true, message: "Por favor informe seu telefone!" },
          ]}
        >
          <InputPhone />
        </Form.Item>
      </div>

      <div className="duasCollumn">
        <Form.Item
          className="inputStyle"
          name="genero"
          label="Gênero"
          rules={[
            { required: true, message: "Por favor, informe o seu gênero!" },
          ]}
        >
          <Select
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            <Option value="MASCULINO">Masculino</Option>
            <Option value="FEMININO">Feminino</Option>
            <Option value="NAO_INFORMADO">Não informar</Option>
          </Select>
        </Form.Item>

        <div className="sizeBoxWidth" />

        <Form.Item
          className="inputStyle"
          name="estadoCivil"
          label="Estado civil"
          rules={[
            {
              required: true,
              message: "Por favor, informe o seu Estado civil!",
            },
          ]}
        >
          <Select
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            <Option value="SOLTEIRO">Solteiro</Option>
            <Option value="CASADO">Casado</Option>
            <Option value="SEPARADO">Separado</Option>
            <Option value="DIVORCIADO">Divorciado</Option>
            <Option value="VIUVO">Viúvo</Option>
          </Select>
        </Form.Item>
      </div>

      {/* <Form.Item label="Estado civil:">
          <Radio.Group name="radiogrupEstadoCivil" defaultValue={1}>
            <Radio value="solteiro">Solteiro</Radio>
            <Radio value="casado">Casado</Radio>
            <Radio value="separado">Separado</Radio>
            <Radio value="divorciado">Divorciado</Radio>
            <Radio value="viuvo">Viúvo</Radio>
          </Radio.Group>
        </Form.Item> */}

      <Form.Item
        className="inputStyle"
        label="Mãe"
        name="nomeMae"
        rules={[
          { required: true, message: "Por favor informe o nome da mãe!" },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        className="inputStyle"
        label="Pai"
        name="nomePai"
        rules={[
          { required: false, message: "Por favor informe o nome do Pai!" },
        ]}
      >
        <Input />
      </Form.Item>
    </>
  );
}
